const MAX_EDGE = 2000;

function readAsBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1]);
    r.onerror = () => reject(new Error('Datei konnte nicht gelesen werden'));
    r.readAsDataURL(blob);
  });
}

/**
 * Bilder vor dem Upload verkleinern (Handyfotos haben oft 5–10 MB) und als JPEG kodieren.
 * Andere Dateien gehen unverändert durch.
 * @returns {Promise<{ fileName: string, base64: string }>}
 */
export async function prepareUpload(file) {
  const isImage = /^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type);
  if (!isImage || typeof createImageBitmap !== 'function') {
    return { fileName: file.name, base64: await readAsBase64(file) };
  }
  try {
    const bmp = await createImageBitmap(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(bmp.width, bmp.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext('2d').drawImage(bmp, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.85));
    const base = file.name.replace(/\.[^.]+$/, '') || 'Foto';
    return { fileName: `${base}.jpg`, base64: await readAsBase64(blob) };
  } catch {
    return { fileName: file.name, base64: await readAsBase64(file) };
  }
}

/** Dateiname für Kamera-Fotos: Foto_2026-10-29_1432.jpg */
export function photoName(prefix = 'Foto') {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${prefix}_${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}${p(d.getSeconds())}.jpg`;
}

export const isImageName = (name) => /\.(jpe?g|png|webp|heic|heif|gif|svg)$/i.test(name ?? '');
export const extOf = (name) => (String(name).split('.').pop() || '').toUpperCase().slice(0, 4);
export function extClass(name) {
  const e = extOf(name);
  if (e === 'PDF') return 'pdf';
  if (['JPG', 'JPEG', 'PNG', 'WEBP', 'HEIC', 'GIF', 'SVG'].includes(e)) return 'img';
  if (['XLSX', 'XLS', 'CSV'].includes(e)) return 'xls';
  return '';
}
